/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const BankAccount: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.5779 3.20522C11.8562 3.14513 12.144 3.14513 12.4223 3.20522C12.7441 3.27472 13.0294 3.44393 13.2563 3.57851L13.3183 3.61522L21.0071 8.13791C21.3959 8.36662 21.5835 8.82733 21.465 9.26258C21.3464 9.69783 20.9512 9.99985 20.5001 9.99985H19.5V18H20.5001C21.0524 18 21.5001 18.4477 21.5001 19C21.5001 19.5523 21.0524 20 20.5001 20H18.5H12H5.50002H3.50015C2.94786 20 2.50015 19.5523 2.50015 19C2.50015 18.4477 2.94786 18 3.50015 18H4.50002V9.99985H3.50009C3.04899 9.99985 2.65374 9.69783 2.53522 9.26258C2.4167 8.82733 2.60426 8.36662 2.99308 8.13791L10.6819 3.61522L10.7439 3.5785C10.9708 3.44393 11.2561 3.27472 11.5779 3.20522ZM6.50002 18H11V9.99985H6.50002V18ZM13 18H17.5V9.99985H13V18ZM11.995 5.16839C11.9345 5.19924 11.8536 5.24635 11.6959 5.3391L7.17248 7.99985H16.8277L12.3043 5.3391C12.1466 5.24635 12.0657 5.19924 12.0052 5.16839L12.0001 5.1658L11.995 5.16839Z'
      fill='currentColor'
    />
  </React.Fragment>
)
